// extracted by mini-css-extract-plugin
export default {"container":"EmailListItem_container__QJP8x","deleteButton":"EmailListItem_deleteButton__2HwaS","valueInput":"EmailListItem_valueInput__g33RV"};